import type { RdiiInflow, UnitHydrograph } from "../model/inp/rdii.ts";
import { useT } from "../i18n/hooks.ts";
import { NumberInput } from "./fields.tsx";

/** [RDII] for one node — a node has at most one RDII inflow. */
export function RdiiEditor({
  nodeName,
  unitHydrographs,
  inflow,
  onChange,
}: {
  nodeName: string;
  unitHydrographs: UnitHydrograph[];
  inflow: RdiiInflow | null;
  onChange: (inflow: RdiiInflow | null) => void;
}) {
  const t = useT();

  function toggle(on: boolean) {
    onChange(
      on ? { node: nodeName, unitHydrograph: unitHydrographs[0]?.name ?? "", sewerArea: 0 } : null
    );
  }

  if (unitHydrographs.length === 0) {
    return (
      <section className="property-panel-group">
        <h3>{t("rdii.inflowTitle")}</h3>
        <p className="property-panel-hint">{t("rdii.noHydrographsYet")}</p>
      </section>
    );
  }

  return (
    <section className="property-panel-group">
      <h3 className="lid-layer-toggle">
        <label>
          <input
            type="checkbox"
            checked={inflow !== null}
            onChange={(e) => toggle(e.target.checked)}
          />
          {t("rdii.inflowTitle")}
        </label>
      </h3>
      {inflow && (
        <div className="named-collection-fields">
          <label className="options-field">
            {t("rdii.unitHydrograph")}
            <select
              value={inflow.unitHydrograph}
              onChange={(e) => onChange({ ...inflow, unitHydrograph: e.target.value })}
            >
              {unitHydrographs.map((uh) => (
                <option key={uh.name} value={uh.name}>
                  {uh.name}
                </option>
              ))}
            </select>
          </label>
          <label className="options-field">
            {t("rdii.sewerArea")}
            <NumberInput
              value={inflow.sewerArea}
              onChange={(v) => onChange({ ...inflow, sewerArea: v })}
            />
          </label>
        </div>
      )}
    </section>
  );
}
